<template>
	<div class="page-journal">
		<header-page
			:button-delete="!openMobile"
			search-header
			:button-filter="!openMobile"
			:button-close="openMobile"
			:title="$route.meta.title"
			to-show
			:show-excel="false"
			:show-clean="false"
			:code-journal="codeDetailJournal"
			:date-journal="dateDetailJournal"
			:detail-journal-open="detailJournalOpen"
			tabindex="-1"
			@delete-journal="deleteJournal"
			@delete-action="onClickIcon"
			@on-search-event="onSearch"
			@run-action="runAction"
			@click-close="closeMobile"
			@click-filter="clickFilter"
		></header-page>
		<div v-if="loadingData" class="text-xs-center title-modal">
			Cargando información.
		</div>
		<v-layout tabindex="-1">
			<v-flex>
				<v-alert
				:value="!currentSubsidiary.id" type="warning">
					Seleccione una empresa
				</v-alert>
			</v-flex>
		</v-layout>
		<v-layout wrap row align-center py-2 class="background-heading" tabindex="-1" 	v-if="currentSubsidiary.id">
			<v-flex  xs2 mr-1>
				<v-layout wrap align-center justify-center class="should-color">
					<v-flex>
						<div font-weight-bold class="d-flex px-0 justify-center">
							<span class="debitV">Desde: {{ params.startDate ?  params.startDate : 'Todos'}}</span>
						</div>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex  xs2 mr-1>
				<v-layout wrap align-center justify-center class="should-color">
					<v-flex>
						<div font-weight-bold class="d-flex px-0 justify-center">
							<span class="debitV">Hasta: {{  params.endDate ?  params.endDate: 'Todos' }}</span>
						</div>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex  xs2 mr-1>
				<v-layout wrap align-center justify-center class="should-color">
					<v-flex>
						<div font-weight-bold class="d-flex px-0 justify-center">
							<span class="debitV">E. de Asiento:  {{ getSquareLabel(params.status) }}</span>
						</div>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex  xs2 mr-1>
				<v-layout wrap align-center justify-center class="should-color">
					<v-flex>
						<div font-weight-bold class="d-flex px-0 justify-center">
							<span class="debitV">T. de Asiento {{ getSquareLabel(params.square) }}</span>
						</div>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex  xs2 mr-1>
				<v-layout wrap align-center justify-center class="should-color">
					<v-flex>
						<div font-weight-bold class="d-flex px-0 justify-center">
							<span class="debitV">Origen: {{ getModuleLabel(moduleName) }}</span>
						</div>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout wrap pb-4>
			<v-flex
				xs12 md6 class="content-journal-heading"
				v-if="journalList && !openMobile && currentSubsidiary.id"
				tabindex="-1"
			>
				<journal-list
					:check-all="checkAll"
					:current-page="currentPage"
					:last-page="table.lastPage"
					:rows="table.rows"
					tabindex="-1"
					:items-total-quantity="table.itemTotal"
					:items-quantity="table.rows.length"
					:loading="loading"
					@add-icon="createAction"
					@clear-filter="clearFilter"
					@click-icon="onClickIcon"
					@create-action="createAction"
					@delete-seat="runAction"
					@confirm-seat="saveAccouting"
					@detail-journal-list="mobileDetail"
					@on-page="onPage"
					@on-search="onSearch"
					@on-selected-all="onSelectedAll"
					@on-table-option="onTableOption"
					@open-detail="openDetail"
					@row-is-selected="rowIsSelected"
					@clone-seat="cloneSeat"
					@print-seat="printSeat"
				></journal-list>
			</v-flex>
			<v-flex
				xs12 md5
				class="content-detail"
				:class="{ 'open': openMobile }"
				v-if="currentSubsidiary.id"
			>
				<v-layout row wrap v-if="showSeatForm">
						<v-flex xs12 class="title-heading pt-1">
							Nuevo asiento
						</v-flex>
						<v-flex xs12 class="body-seat-form">
							<v-layout row wrap align-end>
								<v-flex xs4 pr-2>
									<v-select
										class="filter-select shadow-inset select-autocomplete-create"
										v-if="modules.length > 0"
										id="focus-new-seat"
										:disabled="modules.length === 0 || modules.length === 1"
										hide-details
										:items="modulesFilter"
										item-text="name"
										item-value="id"
										placeholder="Origen"
										:readonly="modules.length === 0 || modules.length === 1"
										single-line
										:value="moduleValue"
										return-object
										:tabindex="modules.length === 0 || modules.length === 1 ? -1 : 1"
										@input="setModuleData"
									></v-select>
								</v-flex>
								<v-flex xs5>
									<app-input-text
										model="gloss"
										:id="modules.length === 0 || modules.length === 1 ? 'focus-new-seat' : ''"
										placeholder="Descripción"
										:tabindex="modules.length === 0 || modules.length === 1 ? 1 : 2"
										:text="model.gloss"
										@input="setModelData"
									></app-input-text>
								</v-flex>
								<v-flex xs3 pl-2>
									<date-component
										:date="model.date"
										icon="/static/img/calendar.svg"
										placeholder="Fecha"
										:tabindex="modules.length === 0 || modules.length === 1 ? 2 : 3"
										@on-input="setModelData({ model: 'date', value: $event })"
									></date-component>
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12 class="title-heading pt-1">
							Detalles
						</v-flex>
						<v-flex xs12 class="body-seat-form">
							<v-layout row wrap align-start>
								<v-flex xs8>
									<autocomplete-component
										append-icon="expand_more"
										http-code="$http"
										id="focus-added"
										:item="accountingAccount"
										item-text="fullName"
										item-value="id"
										:items="accounts"
										model="accountingAccount"
										autocomplete
										placeholder-value="Buscar cuenta contable"
										placeholder-input="Nombre de la cuenta"
										prop="account"
										prop-search="fullName"
										:readonly-prop="accountingAccount.name"
										readonly-prop-show
										:resource-url="`accounting-plan/${params.subsidiaryId}/subsidiary?status=1`"
										return-object
										select-create
										:tabindex="modules.length === 0 || modules.length === 1 ? 3 : 4"
										@return-data="setData"
									></autocomplete-component>
								</v-flex>
								<v-flex xs4 pl-2>
									<app-input-text
										model="reference"
										placeholder="Referencia"
										:tabindex="modules.length === 0 || modules.length === 1 ? 4 : 5"
										:text="modelDetail.reference"
										@input="setModelData"
									></app-input-text>
								</v-flex>
								<v-flex xs4 pr-2>
									<app-input-text
										model="concept"
										placeholder="Concepto"
										:tabindex="modules.length === 0 || modules.length === 1 ? 5 : 6"
										:text="modelDetail.concept"
										@input="setModelData"
									></app-input-text>
								</v-flex>
								<v-flex xs4>
									<autocomplete-component
										append-icon="expand_more"
										http-code="$http"
										:item="modelDetail.costCenterId"
										item-text="name"
										item-value="id"
										:items="costCenters"
										model="costCenterId"
										:show-clear="true"
										placeholder-value="Centro de costos"
										prop="name"
										prop-search="name"
										:resource-url="`cost-center/${params.subsidiaryId}/subsidiary`"
										return-object
										select-create
										:tabindex="modules.length === 0 || modules.length === 1 ? 6 : 7"
										@return-data="setCostCenter"
									></autocomplete-component>
								</v-flex>
								<v-flex xs2 pl-2>
									<app-input-text
										model="amount"
										:text="modelDetail.amount"
										:tabindex="modules.length === 0 || modules.length === 1 ? 7 : 8"
										tooltip-message="Ingresar el importe con signo negativo (-) para crear detalles de tipo HABER"
										tooltip-on-focused
										type="number"
										placeholder="0.00"
										@input="setModelData"
									></app-input-text>
									<span
										v-if="Number(modelDetail.amount) !== 0"
										:class="`${modelDetail.amount < 0 ? 'error' : 'secondary'}--text caption`">
										Detalle de tipo {{ typeDetail }}
									</span>
								</v-flex>
								<v-flex xs1 text-xs-center>
									<app-tooltip-button
										class="no-movil"
										icon="add_circle_outline"
										:text="validInsertCostCenter 
											? 'Debe seleccionar un Centro de Costo' 
											: disabledBtnAdd 
												? 'Verifique que los campos necesarios estén llenos' 
												: 'Agregar'"
										color="#33cfc7"
										:disabled="disabledBtnAdd || validInsertCostCenter"
										@click-icon="addDetail"
									></app-tooltip-button>
								</v-flex>
							</v-layout>
						</v-flex>
				</v-layout>
				<v-layout v-if="showSeatForm">
					<journal-detail-add
						created-add
						:accounts="accounts"
						:balance="balance"
						:code-journal="codeJournal"
						:cost-centers="costCenters"
						:flagSquareSeats="flagSquareSeats"
						:credit="credit"
						:debit="debit"
						:details="dataSelected"
						:disabled-form-clean="disabledFormClean"
						:disabled-form-save="disabledFormSave"
						:edit-detail-inline="editDetailInline"
						:not-declare="notDeclare"
						:row-detail="rowDetail"
						:row-selected="rowSelected"
						:show-seat-form="showSeatForm"
						:subsidiary-id="params.subsidiaryId"
						:accounting-account="accountingAccount"
						:settings="settings"
						tabindex="-1"
						:to-declare="toDeclare"
						:model-detail="modelDetail"
						:modules="modules"
						:open-detail-seat="openDetailSeat"
						:valid-button="validButtonCostCenter"
						@add-icon="createDetailSeat"
						@clean-all="cleanAll"
						@click-icon="onAction"
						@create-action="createDetailSeat"
						@edit-detail-inline="inlineEditDetail"
						@get-data="setDataDetail"
						@on-click="onClick"
						@on-search="onSearchDetail"
						@open-searcher="openSearcher"
						@save-all="onSaveMultiple"
						@set-data-account="setData"
						@set-cost-center="setCostCenter"
						@set-model-data="setModelData"
						@add-detail="saveDetailSeat"
						@remove-item="removeItem"
						@add-detail-seat="addDetailSeat"
						@import-excel="importExcel"
						@download-format="onDownloadFormat"
					/>
				</v-layout>
				<!-- Tabla para detalle de Asiento -->
				<journal-detail
					v-if="!showSeatForm"
					created-add
					:accounts="accounts"
					:flag-edit-inline="flagEditInline"
					:balance="balance || seccionHeader.balance"
					:code-journal="codeJournal"
					:cost-centers="costCenters"
					:credit="credit"
					:debit="debit"
					:flagDisabledAddSeat="flagDisabledAddSeat"
					:details="dataSelected"
					:disabled-form-clean="disabledFormClean"
					:disabled-form-save="disabledFormSave"
					:edit-detail-inline="editDetailInline"
					:not-declare="notDeclare"
					:row-detail="rowDetail"
					:row-selected="rowSelected"
					:show-seat-form="showSeatForm"
					:subsidiary-id="params.subsidiaryId"
					:accounting-account="accountingAccount"
					tabindex="-1"
					:to-declare="toDeclare"
					:model-detail="modelDetail"
					:modules="modules"
					:open-detail-seat="openDetailSeat"
					:settings="settings"
					:flag-valid="flagValidCostCenter"
					:valid-button="validButtonCostCenter"
					:is-loading="loading"
					:square-amounts="isSquareAmounts"
					@add-icon="createDetailSeat"
					@clean-all="cancelEditionDetail"
					@click-icon="onAction"
					@create-action="createDetailSeat"
					@edit-detail-inline="inlineEditDetail"
					@get-data="setDataDetail"
					@on-click="onClick"
					@on-search="onSearchDetail"
					@open-searcher="openSearcher"
					@save-all="onSaveMultiple"
					@set-data-account="setData"
					@change-date="changeDate"
					@set-cost-center="setCostCenter"
					@set-model-data="setModelData"
					@add-detail="saveNewDetailSeat"
					@add-detail-seat="addDetailSeat"
					@save-all-details="saveAllDetailsEdits"
				/>
			</v-flex>
		</v-layout>
		<action-bar
			class="action-mobile"
			:value-disabled="actionsDisabled"
			:resource-uri="$route.name"
			tabindex="-1"
			@run-action="runAction"
		/>
		<action-sidebar
			:img-src="action.imgSrc"
			tabindex="-1"
			:title="action.title"
			:value="action.value"
			:width="action.width"
			@close-modal="closeModal"
		>
			<slide-searcher
				v-if="isActionCode('searcher')"
				:columns="columns"
				:current-page="currentPageRecords"
				:last-page="lastPage"
				:rows="records"
				@add-record="addRecord"
				@on-close="closeModal"
				@on-page="changePageRecords"
				@on-search="onSearchRecords"
			/>
			<journal-filter-by
				v-if="isActionCode('filter-by')"
				:code="params.code"
				:end-date="params.endDate"
				:flag-cost-center="params.flagCostCenter"
				:start-date="params.startDate"
				:type-register-id="params.typeRegisterId"
				:states="states"
				:status="params.status"
				@close-modal="closeModal"
				@filter-by="filterBy"
			/>
			<journal-cancel-form
				v-if="isActionCode('cancel')"
				:loading="loading"
				:name="rowName"
				@close-modal="closeModal"
				@confirm-cancel="confirmCancel"
			/>
			<journal-detail-delete-form
				v-if="isActionCode('delete')"
				:loading="loading"
				:name="rowDetailName"
				:seat-name="rowName"
				@close-modal="closeModal"
				@on-delete="onDeleteDetailSeat"
			/>
			<journal-seat-form
				v-if="isActionCode('new-seat')"
				:customer="currentSubsidiary.customer"
				:loading="loading"
				:model="model"
				:modules="modules"
				:module-value="moduleValue"
				:subsidiary-id="currentSubsidiary.id"
				@close-modal="closeModal"
				@save="onSave"
				@set-module-data="setModuleData"
			/>
			<journal-detail-form
				v-if="isActionCode('new-detail-seat')"
				:loading="loading"
				:subsidiary-id="params.subsidiaryId"
				:model="model"
				@close-modal="closeModal"
				@save="onSaveDetail"
			/>
			<button
				slot="options"
				class="btn-clear-filter"
				@click="clearFilterMobile"
				v-if="isActionCode('filter-by')"
			>Limpiar Filtro</button>
		</action-sidebar>
		<v-dialog
			content-class="confirmation-dialog"
			v-model="cancelModal"
			max-width="400"
		>
			<v-card class="pa-4">
				<v-card-text class="title text-xs-center pt-4">¿Desea eliminar los asientos seleccionados?</v-card-text>
				<v-card-actions class="justify-center pb-4">
					<button
						type="button"
						class="btn-modal cancel mr-2"
						@click="setId">
						No
					</button>
					<button
						type="button"
						class="btn-modal save ml-2"
						@click="onDeleteSeat">
						Si
					</button>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="showPreviewClone"
			max-width="790"
			persistent
		>
			<preview-clone
				v-if="dataSeatClone && dataSeatClone.details && dataSeatClone.details.length > 0 && modules.length > 0"
				:data-seat="dataSeatClone"
				:accounts="accounts"
				:cost-centers="costCenters"
				:settings="settings"
				:modules="modules"
				@close="closePreview">
			</preview-clone>
		</v-dialog>
		<input 
			type="file" 
			ref="fileInput" 
			@change="handleFileUpload" 
			style="display: none"
		/>
		<v-dialog
			v-model="showDialog"	
			max-width="450"
			persistent>
			<v-card>
				<v-card-text class="card-container">
					<div class="card-container-title">
						<close-icon class="cursor-pointer" @click="closeAlert"></close-icon>
					</div>
					<div class="card-container-list">
						<span>En el documento exportado las siguientes cuentas no se encuentran dentro del plan de cuentas:</span> <br>
						<ul v-for="(item, index) in valuesNotFound" :key="index">
							<li>{{ item }}</li>
						</ul> <br>
						<span>Y las filas se omitieron.</span>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import actionBar from '@/components/shared/action-bar/action-bar';
	import actionSidebar from '@/components/shared/action-sidebar';
	import appInputText from '@/components/autocomplete/app-input-text';
	import autocompleteComponent from '@/components/autocomplete/autocomplete-component';
	import dateComponent from '@/components/autocomplete/date-component';
	import helper from '@/shared/helper';
	import headerContent from '@/components/shared/header-content';
	import journalCancelForm from '@/components/journal/journal-cancel-form';
	import journalDetail from '@/components/journal/journal-detail';
	import journalDetailAdd from '@/components/journal/journal-detail-add';
	import journalDetailDeleteForm from '@/components/journal/journal-detail-delete-form';
	import journalFilter from '@/components/journal/journal-filter';
	import journalDetailForm from '@/components/journal/journal-detail-form';
	import journalFilterBy from '@/components/journal/journal-filter-by';
	import appTooltipButton from '@/components/shared/app-tooltip-button';
	import journalList from '@/components/journal/journal-list';
	import journalSeatForm from '@/components/journal/journal-seat-form';
	import slideSearcher from '@/components/shared/searcher/slide-searcher';
	import previewClone from '@/components/journal/preview-clone-seat';
	import lib from '@/shared/lib';
	import { saveAs } from 'file-saver';
	import * as XLSX from 'xlsx';
	import { format } from 'date-fns';
	import closeIcon from '../../components/shared/icons/close.icon';

	const { exactDate } = helper;

	function beforeDestroy() {
		window.removeEventListener('keydown', this.onKeyPress);
	}

	async function created() {
		window.addEventListener('keydown', this.onKeyPress);
		this.loadStates();
		if (this.currentSubsidiary.id) {
			try {
				const { data: response } = await this.$http.get(`settings/${this.currentSubsidiary.customerId}/${this.currentSubsidiary.id}`);
				/* await this.$http.patch(`automatic-configuration-multiple/${subsidiaryId}`, body); */
				this.settings = response.additionalSettings;
				this.showNotification('La configuración de cuentas contables cargada.');
			} catch (err) {
				if (err.status === 500) {
					this.showGenericError();
				}
			} finally {
				this.loading = false;
			}
			this.setId(
				{ documentNumber: this.currentSubsidiary.documentNumber, id: this.currentSubsidiary.id },
				'subsidiaryId',
			);
		}
		this.accountingAccount.account = '4';
	}
	function removeItem(item) {
		this.seatRemove = item;
		const index = this.dataSelected.findIndex((e) => {
			const prop = e.accountingAccountId ? 'accountingAccountId' : 'id';
			return e[prop] === this.seatRemove[prop] && e.accountingAccountId
			=== this.seatRemove.accountingAccountId;
		});
		if (index > -1) {
			this.dataSelected.splice(index, 1);
		}
		this.debit = this.dataSelected.reduce((a, d) => {
			if (Number(d.amount) >= 0) {
				return a + Number(d.amount);
			}
			return a;
		}, 0);
		this.credit = this.dataSelected.reduce((a, d) => {
			if (Number(d.amount) < 0) {
				return Number(d.amount) + a;
			}
			return a;
		}, 0);
		this.balance = this.dataSelected.reduce((acc, i) => {
			const newAmount = Number(i.amount);
			return Number((acc + newAmount).toFixed(2));
		}, 0);
		if (this.settings.squareSeats) {
			if (this.balance === 0) {
				this.flagSquareSeats = false;
			} else {
				this.flagSquareSeats = true;
			}
		} else if (this.settings.squareSeats === false) {
			this.flagSquareSeats = false;
		}
	}
	function disabledFormSave() {
		console.log(' this.balance::: ', this.balance);
		this.balance = this.balance ? Number(this.balance.toFixed(2)) : 0;
		console.log('this.balance::: ', this.balance);
		// Si el balance es cercano a 0, lo forzamos a 0
		const THRESHOLD = 1e-10;
		if (Math.abs(this.balance) < THRESHOLD) {
			this.balance = 0;
			console.log('this.balance::: ', this.balance);
		}
		console.log('this.dataSelected.length::: ', this.dataSelected.length);
		console.log('this.model.date::: ', this.model.date);
		console.log('this.model.moduleCode ::: ', this.model.moduleCode);
		console.log('this.model.gloss::: ', this.model.gloss);
		return !this.model.gloss || !this.model.date ||
			this.flagCostCenter || this.dataSelected.length <= 1 || this.balance !== 0;
	}
	function disabledCostCenter() {
		if (this.settings.autoCenterCost) {
			const cont = this.dataSelected.reduce((acum, item) => {
				let ac = acum;
				if (item.flagCostCenter) {
					ac += 1;
				}
				return ac;
			}, 0);
			return cont > 0;
		}
		return false;
	}

	function disabledFormClean() {
		const modelKeys = Object.keys(this.model);
		const modelDetailKeys = Object.keys(this.modelDetail);
		return modelKeys.every(mk => !this.model[mk]) && modelDetailKeys.every(mdk =>
			!this.modelDetail[mdk]);
	}

	function openDetail() {
		this.journalList = false;
	}

	function deleteJournal() {
		this.rowsIds = this.rowsSelected.map(row => row.id);
		this.cancelModal = true;
	}

	function mounted() {
		this.params.limit = 60;
	}

	function searchFilterJournal() {
		this.setId(
			{ documentNumber: this.currentSubsidiary.documentNumber, id: this.currentSubsidiary.id },
			'subsidiaryId',
		);
	}

	function addIcon() {
		this.action = {
			code: 'new-seat',
			title: 'Crear Asiento',
			value: true,
		};
	}

	function createAction() {
		const reg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
		if (reg.test(navigator.userAgent)) {
			this.action = {
				code: 'new-seat',
				title: 'Crear Asiento',
				value: true,
				width: 470,
			};
			if (this.moduleValue) {
				if (this.moduleValue.module) {
					this.model.moduleCode = this.moduleValue.module.code;
				}
			}
		} else {
			this.rowDetail = {};
			this.table.rows = this.table.rows.map((r) => {
				const newRow = { ...r };
				newRow.isVisited = false;
				return newRow;
			});
			this.codeJournal = null;
			this.rowSelected = {};
			this.dataSelected = [];
			this.dataSelectedOriginal = [];
			this.credit = null;
			this.debit = null;
			this.toDeclare = false;
			this.notDeclare = false;
			this.openDetailSeat = false;
			this.seccionHeader.currencySymbol = null;
			this.seccionHeader.should = null;
			this.seccionHeader.toHave = null;
			this.seccionHeader.balance = null;
			this.model = {
				code: '',
				currency: '',
				date: format(new Date(), 'YYYY-MM-DD'),
				gloss: '',
				moduleCode: '',
				ruc: '',
			};
			this.modelDetail = {
				accountingAccountId: null,
				account: null,
				concept: '',
				reference: '',
				costCenterId: null,
				amount: null,
			};
			if (this.moduleValue) {
				if (this.moduleValue.module) {
					this.model.moduleCode = this.moduleValue.module.code;
				}
			}
			this.showSeatForm = true;
			this.loadAccounts();
			setTimeout(() => {
				const seatFocus = document.getElementById('focus-new-seat');
				seatFocus.click();
			}, 1000);
		}
	}

	function accountingName() {
		const account = this.accounts.find(acc => acc.account === this.model.account ||
			acc.code === this.model.account) || {};
		return account.name;
	}

	function actionsDisabled() {
		const disabled = this.rowsSelected.length === 0;
		const fewSelected = this.rowsSelected.length !== 1;
		const noSubsidiarySelected = lib.isEmpty(this.currentSubsidiary);
		return [
			{ code: 'delete-seat', disabled },
			{ code: 'new-seat-detail', disabled: fewSelected },
			{ code: 'new-seat', disabled: noSubsidiarySelected },
		];
	}

	function addRecord(record) {
		this.model.account = record.account;
		this.model.accountingAccount = { ...record };
		this.action.value = false;
		this.action.title = '';
		this.action.code = '';
	}

	function changePageRecords(page) {
		this.loadRecords(page);
	}

	function changeAmount(dataSelected) {
		this.debit = dataSelected.reduce((a, d) => a + d.amountDebe, 0);
		this.credit = dataSelected.reduce((a, d) => d.amountHaber + a, 0);
		this.balance = Number((this.debit - this.credit).toFixed(2));
		if (this.settings.squareSeats) {
			if (this.balance === 0) {
				this.flagSquareSeats = false;
			} else {
				this.flagSquareSeats = true;
			}
		} else if (this.settings.squareSeats === false) {
			this.flagSquareSeats = false;
		}
	}

	function closeModal() {
		this.action.value = false;
		this.action.title = '';
		this.action.code = '';
		this.model = {
			code: '',
			currency: '',
			date: null,
			gloss: '',
			moduleCode: '',
			ruc: '',
		};
		this.modelDetail = {
			accountingAccountId: null,
			account: null,
			concept: '',
			reference: '',
			costCenterId: null,
			amount: null,
		};
		this.rowId = null;
		this.rowIdSeat = null;
		delete this.recordsParams.search;
	}

	function closeModelDelete() {
		this.action.value = false;
		this.action.title = '';
		this.action.code = '';
		this.modelDetail = {
			accountingAccountId: null,
			account: null,
			concept: '',
			reference: '',
			costCenterId: null,
			amount: null,
		};
		this.rowId = null;
		this.rowIdSeat = null;
		delete this.recordsParams.search;
	}

	function closeDialog() {
		this.cancelModal = false;
	}

	async function confirmCancel() {
		this.loading = true;
		const payload = {
			moduleCode: this.moduleCode,
		};
		try {
			const response = this.moduleCode === 'COMPRA' ? await this.$http.patch(`accounting-seat-cancel/${this.rowId}?flagCancel=${this.flagCancel}`, payload) :
				await this.$http.patch(`accounting-seat-cancel/${this.rowId}`, payload);
			this.showNotification(`El asiento ${this.rowName} ha sido anulado correctamente.`);
			if (response.status === 200) {
				if (this.moduleCode === 'CAJA' || this.moduleCode === 'BANCO') {
					await this.$http.patch(`accounting-seats-cash-bank-cancel?subsidiaryId=${this.currentSubsidiary.id}`, { ids:	[this.rowId] });
				}
			}
			this.rowsIds = [this.rowId];
			this.onDeleteSeatInline();
			this.rowId = null;
			this.rowName = '';
			this.closeModal();
			this.params.subsidiaryId = this.subsidiaryId || this.currentSubsidiary.id || null;
			this.params.page = 1;
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			} else if (err.status === 400) {
				if (err.data.message === 'COM_ACCOUNTING_SEATS_CANCELED') {
					this.showGenericError('El asiento ya se encuentra anulado.');
				}
			}
		} finally {
			this.loading = false;
		}
	}

	function filterBy(filters) {
		this.showSeatForm = false;
		this.dataSelected = [];
		this.rowSelected = {};
		this.balance = 0;
		this.credit = 0;
		this.debit = 0;
		if (filters.documentId) {
			this.params.documentId = filters.documentId;
		}
		if (filters.square) {
			this.params.square = filters.square;
		}
		if (filters.typeRegisterId) {
			this.moduleName = filters.typeRegisterId.name;
			this.params.typeRegisterId = filters.typeRegisterId.id;
		}
		/* if (filters.status === 1) {
			this.flagDisabledAddSeat = true;
		} else {
			this.flagDisabledAddSeat = false;
		} */
		this.closeModal();
		({ code: this.params.code, endDate: this.params.endDate,
			flagCostCenter: this.params.flagCostCenter, startDate: this.params.startDate,
			status: this.params.status } = filters);
		this.params.page = 1;
		this.loadData('accounting-seats');
	}

	function isActionCode(code) {
		return this.action.code === code;
	}

	async function loadCostCenters() {
		({ data: this.costCenters } = await this.$http.get(
			`cost-center/${this.params.subsidiaryId}/subsidiary`));
	}

	async function loadDetail(id) {
		try {
			({ data: this.dataSelected } = await this.$http.get(`accounting-seats/${id}`));
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			} else if (err.status === 400) {
				if (err.data.message === 'COM_ACCOUNTING_SEATS_NOT_FOUND') {
					this.showGenericError('El asiento no existe.');
				}
			}
		}
	}

	async function loadModules() {
		if (this.params.subsidiaryId) {
			({ data: this.modules } = await this.$http.get(
				`modules/${this.params.subsidiaryId}/subsidiary`));
			this.model.currency = this.isEcuador ? 'USD' : null;
			if (this.modules.length === 1 && !this.model.code) {
				this.moduleValue = this.modules[0];
				this.setModuleData(this.moduleValue);
			} else if (this.model.moduleCode) {
				this.moduleValue = this.modules.find(m => m.module.code === this.model.moduleCode);
				this.setModuleData(this.moduleValue);
			}
			const filterModules = this.modules.filter(items => items.name === 'CONTABILIDAD');
			this.modulesFilter = filterModules;
		} else if (!this.currentSubsidiary.id) {
			this.showNotification('Seleccione una empresa.', 'warning');
		}
	}

	async function loadRecords(page = 1) {
		this.currentPageRecords = page;
		this.recordsParams.page = page;
		try {
			const { data: records, headers } = await this.$http.get(
				`accounting-plan/${this.params.subsidiaryId}/subsidiary`,
				{ params: this.recordsParams });
			this.lastPage = Number(headers['x-last-page']);
			this.records = [...records];
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		}
	}

	async function loadStates() {
		({ data: this.states } = await this.$http.get('accounting-seats-states'));
	}

	function onClean() {
		this.params.code = null;
		this.params.endDate = null;
		this.params.flagCostCenter = null;
		this.params.startDate = null;
		this.params.status = null;
		this.params.subsidiaryId = null;
		this.params.typeRegisterId = null;
		this.loadData('accounting-seats');
	}

	function onClick(row) {
		console.log('row::: ', row);
		this.loadCostCenters(row);
		this.setModel('detail', row);
		this.selectDetail(row);
	}

	function onClickIcon({ action, row }) {
		this.moduleCode = row.typeRegister.code;
		if (this.moduleCode === 'CAJA' || this.moduleCode === 'BANCO') {
			const numberDocument = row.id;
			this.documentNumberUpdate = numberDocument;
		}
		this.rowId = row.id;
		this.rowName = row.gloss;
		if (action === 'new-seat') {
			if (row.id) {
				this.rowSelected = { ...row };
				this.rowIdSeat = this.rowSelected.id;
				this.model.code = row.code;
				this.model.date = row.date;
				this.model.currency = row.currency;
				this.model.gloss = row.gloss;
				this.model.moduleCode = row.typeRegister.code;
				this.showHeadingBtn = true;
				this.action.code = action;
				this.action.title = 'Editar Asiento';
				this.action.width = 400;
				this.action.value = true;
			}
		} else if (action === 'see-detail') {
			// Funcion para ver el detalle del asiento
			this.seeDetail(row);
		} else if (action === 'cancel') {
			this.loading = false;
			this.action.code = action;
			this.action.title = 'Anular Asiento';
			this.action.width = 400;
			this.action.value = true;
		}
	}

	async function onDelete() {
		this.loading = true;
		try {
			const { data: response } = await this.$http.delete(`accounting-seat-details/${this.rowDetailId}`);
			this.showNotification('El detalle de asiento ha sido eliminado correctamente.');
			this.closeModal();
			this.params.subsidiaryId = this.subsidiaryId || this.currentSubsidiary.id;
			this.loadData('accounting-seats');
			this.dataSelected = response.details;
			this.dataSelectedOriginal = response.details;
			this.debit = this.dataSelected.reduce((sum, item) => sum + item.amountDebe, 0);
			this.credit = Number(this.dataSelected.reduce((sum, item) => sum + item.amountHaber, 0) * -1);
			this.balance = response.totalDebe - response.totalHaber;
			this.seccionHeader.balance = Number((response.totalDebe - response.totalHaber).toFixed(2));
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.loading = false;
		}
	}

	function onDeleteDetailSeat() {
		this.editDetailInline = true;
		this.dataSelected.splice(this.indexRowDetail, 1);
		this.action.value = false;
		this.indexRowDetail = null;
		this.isSquareAmounts = this.validateAmountActions(this.dataSelected);
		this.closeModelDelete();
		this.params.subsidiaryId = this.subsidiaryId || this.currentSubsidiary.id;
	}

	async function onDeleteSeat() {
		this.loading = true;
		try {
			// Usamos map en lugar de forEach para obtener un array de promesas
			const promises = this.rowIdsModules.map(async (item) => {
				const { id, moduleName, gloss, additionalInformation } = item;
				if (moduleName === 'CAJA' || moduleName === 'BANCO') {
					const numberDocument = gloss.match(/\d+/)[0];
					this.documentNumberUpdate = numberDocument;
				}
				const payload = {
					moduleCode: moduleName,
				};

				const params = {};
				if (additionalInformation && additionalInformation.flagFacWithDocStatus) {
					params.flagFacWithDocStatus = true;
				}

				const response = moduleName === 'COMPRA'
					? await this.$http.patch(`accounting-seat-cancel/${id}?flagCancel=${this.flagCancel}`, payload)
					: await this.$http.patch(`accounting-seat-cancel/${id}`, payload, { params });

				if (response.status === 200) {
					if (moduleName === 'CAJA' || moduleName === 'BANCO') {
						await this.$http.patch(`accounting-seats-cash-bank-cancel?subsidiaryId=${this.currentSubsidiary.id}`, { ids:	[id] });
					}
				}
			});
			// Esperar a que todas las promesas se resuelvan antes de continuar
			await Promise.all(promises);
		} catch (error) {
			this.showGenericError();
		} finally {
			// Llamar a onDeleteSeatMultiple después de que todas las llamadas se completen
			this.onDeleteSeatMultiple();
		}
	}
	async function onDeleteSeatMultiple() {
		this.loading = true;
		const ids = { ids: this.rowsIds };
		try {
			await this.$http.delete('accounting-seat', { data: ids });
			this.showNotification('La eliminación ha sido realizada correctamente.');
			this.closeModal();
			this.params.subsidiaryId = this.subsidiaryId || null;
			this.params.page = 1;
			this.loadData('accounting-seats');
			if (this.rowsIds.indexOf(this.rowSelected.id) > -1) {
				this.dataSelected = [];
				this.dataSelectedOriginal = [];
				this.rowsSelected = [];
				this.rowIdsModules = [];
				this.rowSelected = {};
			} else {
				this.seeDetail(this.rowSelected);
			}
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.loading = false;
			this.closeDialog();
			this.onSelectedAll();
		}
	}

	async function onDeleteSeatInline() {
		const ids = { ids: this.rowsIds };
		try {
			await this.$http.delete('accounting-seat', { data: ids });
			this.showNotification('La eliminación ha sido realizada correctamente.');
			this.closeModal();
			this.params.subsidiaryId = this.subsidiaryId || null;
			this.loadData('accounting-seats');
			if (this.rowsIds.indexOf(this.rowSelected.id) > -1) {
				this.dataSelected = [];
				this.dataSelectedOriginal = [];
				this.rowsSelected = [];
				this.rowIdsModules = [];
				this.rowSelected = {};
			} else {
				this.seeDetail(this.rowSelected);
			}
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.loading = false;
			this.closeDialog();
		}
	}

	async function onEditHeading() {
		this.loading = true;
		const body = {
			code: this.model.code,
			date: this.model.date,
			gloss: this.model.gloss,
			moduleCode: this.model.moduleCode,
			ruc: this.rucSubsidiary || this.model.ruc,
		};
		try {
			await this.$http.patch(`accounting-seat/${this.rowId}`, body);
			this.showNotification('El asiento ha sido editado correctamente.');
			this.params.subsidiaryId = this.subsidiaryId || null;
			this.loadData('accounting-seats');
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			} else if (err.status === 400) {
				if (err.data.message === 'SUBSIDIARY_NOT_FOUND') {
					this.showGenericError('La sucursal referenciada al asiento no existe.');
				}
			}
		} finally {
			this.loading = false;
		}
	}

	function onInput(value) {
		this.model.account = value;
		this.recordsParams.search = value ? value.trim() : null;
	}

	function onInputDetail({ modelName, value }) {
		this.model[modelName] = value;
	}

	function onPage(page) {
		this.currentPage = page;
		this.params.page = page;
		this.loadData('accounting-seats');
	}

	async function onSave() {
		const method = this.rowId ? 'patch' : 'post';
		const url = this.rowId ? `accounting-seat/${this.rowId}` : 'accounting-seat';
		const action = this.rowId ? 'editar' : 'crear';
		const body = {
			date: format(this.model.date, 'YYYY-MM-DD'),
			gloss: this.model.gloss,
			moduleCode: this.model.moduleCode,
			code: this.model.code,
			currency: this.model.currency,
			ruc: this.currentSubsidiary.documentNumber,
		};
		try {
			await this.$http[method](url, body);
			this.showNotification(`El asiento ha sido ${action} correctamente.`);
			this.closeModal();
			this.params.subsidiaryId = this.subsidiaryId || this.currentSubsidiary.id;
			this.loadData('accounting-seats');
			this.dataSelected = [];
			this.dataSelectedOriginal = [];
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			} else if (err.status === 400) {
				if (err.data.message === 'COM_MODULE_NOT_FOUND');
				this.showGenericError('Modulo no existe.');
			}
		}
	}

	async function onSaveDetail() {
		this.loading = true;
		const method = this.rowDetailId ? 'patch' : 'post';
		const url = this.rowDetailId ? `accounting-seat-details/${this.rowId}/${this.rowDetailId}` : `accounting-seat-details/${this.rowSelected.id}`;
		const action = this.rowDetailId ? 'editar' : 'crear';
		const body = {
			account: this.model.account,
			accountingAccountId: this.model.accountingAccountId,
			concept: this.model.concept,
			reference: this.model.reference,
			costCenterId: this.model.costCenterId,
			amount: this.model.amount,
		};
		try {
			await this.$http[method](url, body);
			this.showNotification(`El detalle de asiento ha sido ${action} correctamente.`);
			this.closeModal();
			this.params.subsidiaryId = this.subsidiaryId || this.currentSubsidiary.id;
			await this.loadData('accounting-seats');
			this.seeDetail(this.rowSelected);
		} catch (err) {
			this.showGenericError();
		}
	}

	function onSearch(value) {
		this.currentPage = 1;
		this.params.page = this.currentPage;
		this.params.search = value ? value.trim() : null;
		this.loadData('accounting-seats');
	}

	function onSearchDetail(value) {
		const localSearch = value ? value.trim() : '';
		if (value.length) {
			this.dataSelected = [...this.dataSelectedOriginal];
			const rowsFilter = this.dataSelected.filter(item =>
				(item.account.toLowerCase().indexOf(localSearch.toLowerCase()) > -1));
			this.dataSelected = rowsFilter;
		} else {
			this.dataSelected = [...this.dataSelectedOriginal];
		}
	}

	function onSearchRecords(searchTable) {
		this.recordsParams.search = searchTable ? searchTable.trim() : null;
		this.loadRecords();
	}

	function onSelectedAll(checked) {
		this.checkAll = checked;
		this.table.rows = this.table.rows.map((tableRow) => {
			const newTableRow = { ...tableRow };
			newTableRow.isSelected = checked;
			return newTableRow;
		});
		this.rowsSelected = this.table.rows.filter(tableRow => tableRow.isSelected);
		this.dataSelected = [];
		this.dataSelectedOriginal = [];
	}

	function onTableOption(item) {
		this.action = { ...item };
		this.action.value = item.open;
		this.action.width = 371;
	}

	function onAction({ action, row, index }) {
		console.log('index::: ', index);
		console.log('row::: ', row);
		console.log('action::: ', action);
		this.indexRowDetail = index;
		const reg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
		try {
			if (reg.test(navigator.userAgent) || action === 'delete') {
				const seat = this.table.rows.find(r => r.id === row.accountingSeatId) || {};
				this.rowId = seat.id;
				this.rowName = seat.gloss;
				this.params.subsidiaryId = seat.subsidiaryId;
				this.rowDetailId = row.id;
				this.rowDetailName = row.accountingAccount.name;
				this.action.width = 400;
				this.action.code = action;
				if (action === 'new-detail-seat') {
					if (this.model) {
						this.onClick(row);
						this.action.title = 'Editar Detalle de Asiento';
						this.model.accountingAccountId = row.accountingAccountId;
					}
				} else if (action === 'delete') {
					this.action.title = 'Eliminar Detalle de Asiento';
				}
				this.action.value = true;
			} else {
				this.editDetailInline = true;
				this.openDetailSeat = false;
				this.modelDetail = { ...row };
				this.dataSelected = this.dataSelected.map((ds, indexD) => {
					const newDataSelected = { ...ds };
					newDataSelected.onEdit = indexD === this.indexRowDetail;
					return newDataSelected;
				});
				const focusDetailEdit = document.getElementById('focus-edit-inline');
				focusDetailEdit.click();
			}
		} catch (error) {
			console.log('error::: ', error);
		}
	}

	function validButtonCostCenter() {
		const accounts = this.dataSelected.filter(item =>
			['4', '5', '6', '7', '8'].includes(item.account ? item.account.charAt(0) :
				item.accountingAccount.code.charAt(0)));
		if (this.settings.autoCenterCost) {
			if (accounts.length > 0) {
				const costCenterLength = accounts.filter(item => item.costCenterId === null).length;
				if (costCenterLength > 0) {
					this.showNotification('Hay cuentas con 4, 5, 6, 7, 8 sin centro de costo asignado');
				}
				return costCenterLength > 0;
			}
			return false;
		}
		return false;
	}

	function openSearcher() {
		this.action.title = 'Cuentas Contables';
		this.action.code = 'searcher';
		this.action.width = 550;
		this.action.value = true;
		this.recordsParams.search = this.model.accountingCode;
		this.loadRecords();
	}

	function rowIsSelected() {
		this.checkAll = this.table.rows.every(tableRow => tableRow.isSelected);
		this.rowsSelected = this.table.rows.filter(tableRow => tableRow.isSelected);
	}

	function currencySymbol(rowSelected) {
		return rowSelected.currency === 'PEN' ? 'S/.' : null;
	}

	function runAction({ code, name }) {
		if (code === 'delete-seat') {
			this.rowsIds = this.rowsSelected.map(row => row.id);
			this.rowIdsModules = this.rowsSelected.map(row => ({
				id: row.id,
				moduleName: row.typeRegister.code,
				gloss: row.gloss,
				additionalInformation: row.additionalInformation ? row.additionalInformation : {},
			}));
			this.cancelModal = true;
		} else {
			this.action.code = code;
			this.action.title = name;
			this.action.width = code === 'delete-seat' ? 300 : 400;
			this.action.value = true;
		}
	}

	async function subsidiaryChange(newSubsidiary) {
		if (newSubsidiary.id) {
			this.setId(
				{ documentNumber: newSubsidiary.documentNumber, id: newSubsidiary.id },
				'subsidiaryId',
			);
		} else {
			this.table.rows = [];
		}
	}

	function setId({ documentNumber, id }, modelName) {
		this.params[modelName] = id;
		if (modelName === 'subsidiaryId') {
			this.rucSubsidiary = documentNumber;
		}
		this.currentPage = 1;
		this.params.page = this.currentPage;
		this.dataSelected = [];
		this.dataSelectedOriginal = [];
		this.rowIdsModules = [];
		this.seccionHeader = {
			balance: null,
			currencySymbol: null,
			should: null,
			toHave: null,
		};
		this.credit = null;
		this.debit = null;
		this.cancelModal = false;
		this.headingSeat = false;
		this.notDeclare = false;
		this.toDeclare = false;
		this.loading = false;
		this.loadAccounts();
		this.loadModules();
		this.loadCostCenters();
		this.loadData('accounting-seats');
		this.table.rows = this.table.rows.map((row) => {
			const newRow = { ...row };
			newRow.isVisited = false;
			return newRow;
		});
	}

	async function saveAccouting(id) {
		const body = {
			ids: [id],
		};
		try {
			await this.$http.patch('accounting-seat/confirm', body);
			this.showNotification('Los asientos fueron asignados correctamente');
		} catch (error) {
			this.showGenericError();
		}
	}

	function setHeadingData({ modelName, value }) {
		const condition = modelName === 'moduleId';
		this.model[modelName] = condition ? value.id : value;
		if (condition) {
			this.model.moduleCode = value.code;
		}
	}

	function setModel(type, row) {
		console.log('row::: ', row);
		try {
			if (type === 'heading') {
				this.model.code = row.code;
				this.model.date = exactDate(row.date, 'YYYY-MM-DD');
				this.model.gloss = row.gloss;
				this.model.moduleId = row.moduleId || row.typeRegister.id;
				this.model.ruc = row.ruc;
				this.model.account = null;
				this.model.accountingAccount = {};
				this.model.amount = null;
				this.model.concept = null;
				this.model.costCenterId = null;
				this.model.reference = null;
				this.params.subsidiaryId = row.subsidiaryId;
			} else {
				this.model.account = row.account;
				this.model.accountingAccount = row.accountingAccount;
				this.model.amount = row.amount;
				this.model.concept = row.concept;
				this.model.costCenterId = row.costCenterId;
				this.model.reference = row.reference;
			}
		} catch (error) {
			console.log('error::: ', error);
		}
	}

	function createDetailSeat() {
		this.action = {
			code: 'new-detail-seat',
			title: 'Nuevo detalle de asiento',
			value: true,
			open: true,
		};
	}

	function detailJournalList() {
		this.openDetailMobile = false;
	}

	function returnJournal() {
		this.openDetailMobile = true;
	}

	function clickFilter() {
		this.action.title = 'Filtros';
		this.action.code = 'filter-by';
		this.action.value = true;
	}
	function getSquareLabel(square) {
		if (square === 1) {
			return 'Cuadrado';
		} else if (square === undefined || square === null) {
			return 'Todos';
		}
		return 'No Cuadrado';
	}

	function getModuleLabel(module) {
		if (module) {
			return module;
		}
		return 'Todos';
	}

	function getStatusLabel(status) {
		if (status === 1) {
			return 'Mayorizados';
		} else if (status === undefined || status === null) {
			return 'Todos';
		}
		return 'Pendientes';
	}

	function clearFilter() {
		this.params.code = null;
		this.params.endDate = null;
		this.params.startDate = null;
		this.params.flagCostCenter = null;
		this.params.typeRegisterId = null;
		this.params.status = null;
		this.params.square = null;
		this.params.documentId = null;
		this.seccionHeader = {
			balance: null,
			currencySymbol: null,
			should: null,
			toHave: null,
		};
		this.headingSeat = false;
		this.loadData('accounting-seats');
	}

	function clearFilterMobile() {
		this.closeModal();
		this.clearFilter();
	}

	function mobileDetail(row) {
		this.detailJournalOpen = true;
		this.codeDetailJournal = row.code;
		this.dateDetailJournal = exactDate(row.date, 'YYYY-MM-DD');
		const index = this.table.rows.findIndex(t => t.id === row.id);
		if (index > -1) {
			this.dataSelected = this.table.rows[index].details ?
				this.table.rows[index].details.map((detail) => {
					const newDetail = { ...detail };
					newDetail.accountingAccount = detail.accountingAccount || {};
					newDetail.amount = detail.amount || 0;
					newDetail.accountingAccount = detail.accountingAccount || {};
					newDetail.costCenter = detail.costCenter || {};
					return newDetail;
				}) : [];
			this.dataSelectedOriginal = [...this.dataSelected];
			this.rowIdSeat = this.table.rows[index].id;
			this.credit = this.table.rows[index].totalHaber * -1;
			this.debit = this.table.rows[index].totalDebe;
			this.seccionHeader.currencySymbol = this.currencySymbol(this.table.rows[index]);
			this.seccionHeader.should = this.table.rows[index].totalDebe;
			this.seccionHeader.toHave = this.table.rows[index].totalHaber * -1;
			this.seccionHeader.balance =
				Number((this.table.rows[index].totalDebe - this.table.rows[index].totalHaber).toFixed(2));
			if (this.credit === this.debit) {
				this.toDeclare = true;
				this.notDeclare = false;
			}
			if (this.credit !== this.debit) {
				this.notDeclare = false;
			}
			if (this.seccionHeader.balance > 0 || this.balance > 0) {
				this.notDeclare = true;
			}
			this.openMobile = true;
		}
	}

	function closeMobile() {
		this.detailJournalOpen = false;
		this.openMobile = false;
	}

	function selectDetail(row) {
		try {
			this.rowDetail = { ...row };
			this.dataSelected = this.dataSelected.map((d) => {
				const newRow = { ...d };
				newRow.isSelected = d.id === row.id;
				return newRow;
			});
			this.dataSelectedOriginal = this.dataSelectedOriginal.map((d) => {
				const newRow = { ...d };
				newRow.isSelected = d.id === row.id;
				return newRow;
			});
		} catch (error) {
			console.log('error::: ', error);
		}
	}

	function seeDetail(row) {
		// Este row es la data del asiento.
		this.rowDetail = {};
		this.showSeatForm = false;
		this.loadAccounts();
		this.table.rows = this.table.rows.map((r) => {
			const newRow = { ...r };
			newRow.isVisited = r.id === row.id;
			return newRow;
		});
		this.codeJournal = row.code;
		this.rowSelected = { ...row }; // Asigna da la data del asiento a esta variable
		this.dataSelected = row.details ? row.details.map((detail) => {
			const newDetail = { ...detail };
			newDetail.accountingAccount = detail.accountingAccount || {};
			newDetail.amount = detail.amount || 0;
			newDetail.accountingAccount = detail.accountingAccount || {};
			newDetail.costCenter = detail.costCenter || {};
			return newDetail;
		}) : [];
		this.dataSelectedOriginal = [...this.dataSelected];
		this.credit = row.totalHaber * -1;
		this.debit = row.totalDebe;
		this.balance = row.totalDebe - row.totalHaber;
		this.toDeclare = Math.abs(this.credit) === Math.abs(this.debit);
		this.notDeclare = Math.abs(this.credit) !== Math.abs(this.debit);
		this.seccionHeader.currencySymbol = this.currencySymbol(row);
		this.seccionHeader.should = row.totalDebe;
		this.seccionHeader.toHave = row.totalHaber * -1;
		this.seccionHeader.balance = Number((row.totalDebe - row.totalHaber).toFixed(2));
		this.loadModules(row);
		this.setModel('heading', row);
	}

	async function loadAccounts() {
		this.params.subsidiaryId = this.subsidiaryId || this.currentSubsidiary.id;
		const params = {
			status: 1,
		};
		({ data: this.accounts } = await this.$http.get(
			`accounting-plan/${this.params.subsidiaryId}/subsidiary`, { params }));
		// if (this.showSeatForm) {
		// 	this.accounts = this.accounts.filter(a => a.auxCont === 0);
		// }
	}

	function setCostCenter(value) {
		this.costCenter = { ...value };
		this.modelDetail.costCenterId = value.id;
	}

	function setData(value) {
		console.log('value::: ', value);
		this.accountingAccount = { ...value };
		this.modelDetail.account = value.code;
		this.modelDetail.accountingAccountId = value.id;
		this.modelDetail.codeAccounting = value.account;
	}

	function changeDate(value) {
		this.model.date = value;
		this.model.moduleCode = 'Contabilidad';
		this.onEditHeading();
	}

	function disabledBtnAdd() {
		return (
			!this.modelDetail.accountingAccountId || !this.modelDetail.account ||
			!this.modelDetail.concept || !this.modelDetail.reference || !this.modelDetail.amount
			// (this.accountingAccount.account.startsWith('4')
			// || this.accountingAccount.account.startsWith('5'))
			// && (this.modelDetail.costCenterId === null)
		);
	}

	function setModelData({ model, value }) {
		console.log('valuezz::: ', value);
		console.log('model::: ', model);
		if (model === 'date' || model === 'gloss') {
			this.model[model] = value;
		} else {
			this.modelDetail[model] = value;
		}
		console.log('this.modzzelDetail::: ', this.modelDetail);
		this.balance = this.dataSelected.reduce((acc, item) => {
			const newAmount = Number(item.amount);
			return Number((acc + newAmount).toFixed(2));
		}, 0);
		if (this.settings.squareSeats) {
			if (this.balance === 0) {
				this.flagSquareSeats = false;
			} else {
				this.flagSquareSeats = true;
			}
		} else if (this.settings.squareSeats === false) {
			this.flagSquareSeats = false;
		}
	}

	function setModuleData(moduleData) {
		this.module = { ...moduleData };
		this.model.moduleCode = this.module.module.code;
	}

	async function onSaveMultiple() {
		const body = {
			accountingAccountDetail: this.dataSelected.map(detail => ({
				accountingAccountId: detail.accountingAccountId,
				account: detail.account,
				amount: detail.amount,
				concept: detail.concept,
				costCenterId: detail.costCenterId,
				reference: detail.reference,
				codeAccounting: detail.accountingAccount.account || '',
			})),
			currency: this.isEcuador ? 'USD' : 'PEN',
			date: format(this.model.date, 'YYYY-MM-DD'),
			gloss: this.model.gloss,
			moduleCode: this.model.moduleCode,
			ruc: this.rucSubsidiary,
		};
		try {
			const res = await this.$http.post(
				'accounting-seats/multiple_details', body);
			const bodyConfirm = {
				ids: [res.data.id],
			};
			await this.$http.patch(
				'accounting-seat/confirm',
				bodyConfirm,
			);
			this.showNotification('El asiento y los detalles han sido creados correctamente.');
			await this.loadData('accounting-seats');
			this.seeDetail(this.table.rows[0]);
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		}
	}

	async function saveDetailSeat() {
		this.dataSelected.push({
			...this.modelDetail,
			accountingAccount: this.accountingAccount,
			costCenter: this.costCenter,
		});
		const body = {
			accountingAccountId: this.modelDetail.accountingAccountId,
			account: this.modelDetail.account,
			amount: this.modelDetail.amount,
			concept: this.modelDetail.concept,
			reference: this.modelDetail.reference,
			costCenterId: this.modelDetail.costCenterId,
		};
		console.log('body::: ', body);
		try {
			const { data: response } = await this.$http.post(`/accounting-seat-details/${this.rowSelected.id}`, body);
			this.showNotification('Nuevo Detalle de Asiento guardo correctamente.');
			this.modelDetail = {
				accountingAccountId: null,
				account: null,
				concept: '',
				reference: '',
				costCenterId: null,
				amount: null,
			};
			await this.loadData('accounting-seats');
			this.costCenter = {};
			this.accountingAccount = {};
			this.dataSelected = response.details;
			this.debit = this.dataSelected.reduce((sum, item) => sum + item.amountDebe, 0);
			this.credit = Number(this.dataSelected.reduce((sum, item) => sum + item.amountHaber, 0) * -1);
			this.balance = response.totalDebe - response.totalHaber;
			this.seccionHeader.balance = response.totalDebe - response.totalHaber;
			this.openDetailSeat = false;
		} catch (error) {
			this.showGenericError();
		} finally {
			await this.loadData('accounting-seats');
		}
	}

	async function saveNewDetailSeat() {
		const amount = Number(this.modelDetail.amount);
		const type = amount > 0 ? 'Debe' : 'Haber';
		this.modelDetail.type = amount > 0 ? 1 : 2;
		console.log('this.modelDetail::: ', this.modelDetail);
		this.modelDetail.status = 1;
		this.modelDetail[`amount${type}`] = type === 'Debe' ? amount : (amount * -1);
		const otherType = type === 'Debe' ? 'Haber' : 'Debe';
		this.modelDetail[`amount${otherType}`] = 0;
		this.dataSelected.push({
			...this.modelDetail,
			accountingAccount: this.accountingAccount,
			costCenter: this.costCenter,
		});
		this.modelDetail = {
			accountingAccountId: null,
			account: null,
			concept: null,
			reference: null,
			costCenterId: null,
			amount: null,
		};
		this.costCenter = {};
		console.log('this.dataSelected::: ', this.dataSelected);
		this.accountingAccount = {};
		this.openDetailSeat = false;
		this.isSquareAmounts = this.validateAmountActions(this.dataSelected);
	}

	function addDetail() {
		// Agrega nuevo asiento contable
		this.modelDetail.type = Number(this.modelDetail.amount) > 0 ? 1 : 2;
		const type = this.modelDetail.type === 1 ? 'Debe' : 'Haber';
		const newValue = this.modelDetail.type === 1 ? Number(this.modelDetail.amount) :
			(Number(this.modelDetail.amount) * -1);
		this.modelDetail[`amount${type}`] = newValue;
		if (type === 'Debe') {
			this.modelDetail.amountHaber = 0;
		} else {
			this.modelDetail.amountDebe = 0;
		}
		this.dataSelected.push({
			...this.modelDetail,
			accountingAccount: this.accountingAccount,
			flagCostCenter: this.accountingAccount.account.split('.')[0] === '4' || this.accountingAccount.account.split('.')[0] === '5',
			costCenter: this.costCenter,
		});
		this.modelDetail = {
			accountingAccountId: null,
			account: null,
			concept: null,
			reference: null,
			costCenterId: null,
			amount: null,
		};
		this.costCenter = {};
		this.accountingAccount = {};
		this.accountingAccount.account = '4';
		this.debit = this.dataSelected.reduce((a, d) => {
			if (Number(d.amount) >= 0) {
				return a + Number(d.amount);
			}
			return a;
		}, 0);
		this.credit = this.dataSelected.reduce((a, d) => {
			if (Number(d.amount) < 0) {
				return Number(d.amount) + a;
			}
			return a;
		}, 0);
		this.balance = this.dataSelected.reduce((acc, item) => {
			const newAmount = Number(item.amount);
			return Number((acc + newAmount).toFixed(2));
		}, 0);
		if (this.settings.squareSeats) {
			if (this.balance === 0) {
				this.flagSquareSeats = false;
			} else {
				this.flagSquareSeats = true;
			}
		} else if (this.settings.squareSeats === false) {
			this.flagSquareSeats = false;
		}
		const setFocus = document.getElementById('focus-added');
		setFocus.click();
	}

	function typeDetail() {
		return this.modelDetail.amount < 0 ? 'HABER' : 'DEBE';
	}

	function cleanAll() {
		this.model = {
			code: null,
			currency: null,
			date: format(new Date(), 'YYYY-MM-DD'),
			gloss: null,
			moduleCode: null,
			ruc: null,
		};
		this.modelDetail = {
			accountingAccountId: null,
			account: null,
			concept: null,
			reference: null,
			costCenterId: null,
			amount: null,
		};
		this.debit = 0;
		this.credit = 0;
		this.balance = 0;
		this.seccionHeader.balance = 0;
		this.dataSelected = [];
		this.rowSelected = {};
	}

	function cancelEditionDetail() {
		this.model = {
			code: null,
			currency: null,
			date: null,
			gloss: null,
			moduleCode: null,
			ruc: null,
		};
		this.modelDetail = {
			accountingAccountId: null,
			account: null,
			concept: '',
			reference: '',
			costCenterId: null,
			amount: null,
		};
		this.debit = 0;
		this.credit = 0;
		this.balance = 0;
		this.dataSelected = [];
		this.rowSelected = {};
		this.editDetailInline = false;
	}

	function onKeyPress(event) {
		const ctrlKeyPressed = event.ctrlKey;
		const altKeyPressed = event.altKey;
		const lKeyPressed = event.code === 'KeyL';
		const eKeyPressed = event.code === 'KeyE';
		const keyAccess = ctrlKeyPressed && altKeyPressed && lKeyPressed;
		const keyAccessEdit = ctrlKeyPressed && altKeyPressed && eKeyPressed;
		if (keyAccess) {
			this.createAction();
		}
		if (keyAccessEdit) {
			this.onAction({ row: this.dataSelected[0] });
		}
		if (event.code === 'Escape') {
			this.editDetailInline = false;
			this.model = {
				code: '',
				currency: '',
				date: null,
				gloss: '',
				moduleCode: '',
				ruc: '',
			};
			this.modelDetail = {
				accountingAccountId: null,
				account: null,
				concept: '',
				reference: '',
				costCenterId: null,
				amount: null,
			};
			this.dataSelected = this.dataSelected.map((ds) => {
				const newDataSelected = { ...ds };
				newDataSelected.onEdit = false;
				return newDataSelected;
			});
		}
	}

	function setDataDetail({ model, value, row, index }) {
		if (model === 'reference') {
			this.dataSelected[index].reference = value;
		}
		if (model === 'concept') {
			this.dataSelected[index].concept = value;
		}
		if (model === 'amount') {
			this.$set(this.dataSelected[index], 'amount', value);
			this.$set(this.dataSelected[index], 'type', Number(value) > 0 ? 1 : 2);
			const type = row.type === 1 ? 'Debe' : 'Haber';
			const newValue = row.type === 1 ? Number(value) : (Number(value) * -1);
			this.$set(this.dataSelected[index], `amount${type}`, newValue);
			if (type === 'Debe') {
				this.$set(this.dataSelected[index], 'amountHaber', 0);
			} else {
				this.$set(this.dataSelected[index], 'amountDebe', 0);
			}
			const newData = [...this.dataSelected];
			this.changeAmount(newData);
		}
		if (model === 'accountingAccount') {
			this.modelDetail.account = value.code;
			this.modelDetail.accountingAccountId = value.id;
			this.dataSelected[index].accountingAccount = value;
			this.dataSelected[index].accountingAccountId = value.id;
			this.dataSelected[index].account = value.code;
		}
		if (model === 'costCenter') {
			this.modelDetail.costCenterId = value ? value.id : null;
			this.dataSelected[index].costCenter = value;
			this.dataSelected[index].costCenterId = value ? value.id : null;
			this.dataSelected[index].flagCostCenter = false;
			this.flagValidCostCenter = false;
		}
		this.isSquareAmounts = this.validateAmountActions(this.dataSelected);
	}

	async function inlineEditDetail() {
		try {
			const body = {
				account: this.modelDetail.account,
				accountingAccountId: this.modelDetail.accountingAccountId,
				amount: this.modelDetail.amount,
				concept: this.modelDetail.concept,
				costCenterId: this.modelDetail.costCenterId,
				reference: this.modelDetail.reference,
			};
			try {
				const { data: response } = await this.$http.patch(
					`accounting-seat-details/${this.modelDetail.accountingSeatId}/${this.modelDetail.id}`,
					body,
				);
				this.dataSelected = response.details;
				this.debit = this.dataSelected.reduce((sum, item) => sum + item.amountDebe, 0);
				this.credit = (this.dataSelected.reduce((sum, item) => sum + item.amountHaber, 0) * -1);
				this.balance = response.totalDebe - response.totalHaber;
				this.flagValidCostCenter = false;
				this.seccionHeader.should = this.debit;
				this.seccionHeader.toHave = this.credit;
				this.seccionHeader.balance =
				Number(this.seccionHeader.should - (this.seccionHeader.toHave * -1));
				this.showNotification('Detalle de asiento editado correctamente');
				this.editDetailInline = false;
				this.model = {
					code: '',
					currency: '',
					date: null,
					gloss: '',
					moduleCode: '',
					ruc: '',
				};
				this.modelDetail = {
					accountingAccountId: null,
					account: null,
					concept: '',
					reference: '',
					costCenterId: null,
					amount: null,
				};
			} catch (err) {
				console.log('err::: ', err);
				if (err.status === 500) {
					this.showGenericError();
				}
			}
		} catch (error) {
			console.log('error::: ', error);
		}
	}

	function addDetailSeat() {
		this.clearModels();
		this.openDetailSeat = !this.openDetailSeat;
		this.editDetailInline = true;
		this.dataSelected = this.dataSelected.map((ds) => {
			const newDataSelected = { ...ds };
			newDataSelected.onEdit = false;
			return newDataSelected;
		});
		console.log('this.dataSelect22ed::: ', this.dataSelected);
		this.modelDetail.concept = this.dataSelected.length > 0 ? this.dataSelected[0].concept : null;
		this.modelDetail.reference = this.dataSelected.length > 0 ? this.dataSelected[0].reference : null;
	}

	async function saveAllDetailsEdits() {
		this.loading = true;
		const body = this.formatData(this.dataSelected);
		try {
			const { data: response } = await this.$http.patch(`accounting-seat-update-daily/${this.rowSelected.id}`, body);
			this.rowSelected = response;
			this.dataSelected = response.details;
			this.dataSelected = this.dataSelected.map((ds) => {
				const newDs = { ...ds };
				newDs.accountingAccount = this.accounts.find(a => a.id === ds.accountingAccountId);
				newDs.costCenterId = ds.costCenterId ? ds.costCenterId : null;
				newDs.amount = ds.amountDebe > 0 ? ds.amountDebe : (ds.amountHaber * -1);
				return newDs;
			});
			this.params.subsidiaryId = this.subsidiaryId || this.currentSubsidiary.id;
			this.debit = this.dataSelected.reduce((sum, item) => sum + item.amountDebe, 0);
			this.credit = (this.dataSelected.reduce((sum, item) => sum + item.amountHaber, 0) * -1);
			this.balance = response.totalDebe - response.totalHaber;
			this.seccionHeader.balance = response.totalDebe - response.totalHaber;
			this.showNotification('Detalles actualizados Correctamente');
			await this.loadData('accounting-seats');
			this.clearModels();
		} catch (error) {
			this.showGenericError();
		} finally {
			this.editDetailInline = false;
			this.openDetailSeat = false;
			this.loading = false;
		}
	}

	function formatData(value) {
		console.log('value::: ', value);
		const totalDebe = value.reduce((sum, item) => sum + item.amountDebe, 0);
		const totalHaber = value.reduce((sum, item) => sum + item.amountHaber, 0);
		const details = value.map((d) => {
			const newD = {};
			newD.id = d.id ? d.id : null;
			newD.type = d.type;
			newD.account = d.account || null;
			newD.concept = d.concept;
			newD.reference = d.reference;
			newD.amountDebe = Number(d.amountDebe);
			newD.amountHaber = Number(d.amountHaber);
			newD.costCenterId = d.costCenterId ? d.costCenterId : null;
			newD.accountingAccountId = d.accountingAccountId;
			newD.codeAccounting = d.codeAccounting;
			return newD;
		});
		const newData = {
			totalDebe,
			totalHaber,
			details,
		};
		if (this.rowSelected.clone === 1) {
			newData.clone = 2;
		}
		return newData;
	}

	function validateAmountActions(array) {
		this.debit = Number(array.reduce((sum, item) => sum + item.amountDebe, 0).toFixed(2));
		console.log('this.debit::: ', this.debit);
		this.credit = Number((array.reduce((sum, item) => sum + item.amountHaber, 0) * -1).toFixed(2));
		console.log('this.credit::: ', this.credit);
		const credit = (this.credit * -1);
		this.balance = this.debit - credit;
		const THRESHOLD = 1e-10;
		if (Math.abs(this.balance) < THRESHOLD) {
			this.balance = 0;
			console.log('this.balance::: ', this.balance);
		}
		console.log('this.balance40::: ', this.balance);
		this.seccionHeader.balance = this.debit - credit;
		return this.debit > credit || this.debit < credit;
	}

	function clearModels() {
		this.modelDetail = {
			accountingAccountId: null,
			account: null,
			concept: '',
			reference: '',
			codeAccounting: null,
			costCenterId: null,
			amount: null,
		};
	}
	function validInsertCostCenter() {
		let valid = false;
		if (this.settings.autoCenterCost) {
			if (this.modelDetail.account) {
				const firstDigit = this.modelDetail.account.charAt(0);
				if ((Number(firstDigit) >= 4 && Number(firstDigit <= 8)) && !this.modelDetail.costCenterId) {
					valid = true;
				}
			}
			return valid;
		}
		return valid;
	}
	async function cloneSeat(row) {
		this.loading = true;
		const params = {
			subsidiaryId: this.currentSubsidiary.id,
		};
		if (row.clone === 1) {
			this.showNotification('Asiento Clonado Pendiente para Revisión', 'warning');
		} else {
			try {
				const { data: response } = await this.$http.post(`/accounting-seat-clone/${row.id}`, null, { params });
				this.dataSeatClone = response;
				this.loadModules(response);
				this.showNotification('Asiento Clonado Exitosamente');
				this.showPreviewClone = true;
				await this.loadData('accounting-seats');
			} catch (error) {
				this.showGenericError();
			} finally {
				this.loading = false;
			}
		}
		this.loading = false;
	}
	async function closePreview() {
		this.showPreviewClone = false;
		await this.loadData('accounting-seats');
		this.dataSeatClone = {};
		this.openDetailSeat = false;
	}
	async function printSeat(row) {
		try {
			const payload = {
				code: 'report-seat',
			};
			const params = {
				subsidiaryId: row.subsidiaryId,
			};
			const { data: response } = await this.$http.post(`/accounting-seats/${row.id}/print`, payload, { params });
			const contentType = 'text/html';
			if (contentType !== 'text/html') {
				this.showGenericError('El archivo no es HTML');
				return;
			}
			const iframe = document.createElement('iframe');
			iframe.style.display = 'none';
			document.body.appendChild(iframe);
			iframe.contentDocument.open();
			iframe.contentDocument.write(response);
			iframe.contentDocument.close();
			await new Promise((resolve) => {
				iframe.onload = resolve;
			});
			iframe.contentWindow.print();
			this.showNotification('Archivo PDF descargado exitosamente.');
		} catch (error) {
			this.showGenericError();
		}
	}

	function importExcel() {
		this.$refs.fileInput.click();
	}

	function handleFileUpload(event) {
		const file = event.target.files[0];
		if (!file) return;
		const reader = new FileReader();
		let jsonData;
		reader.onload = (e) => {
			this.loadingData = true;
			const dataFile = new Uint8Array(e.target.result);
			const workbook = XLSX.read(dataFile, { type: 'array' });
			const sheetName = workbook.SheetNames[0];
			const sheet = workbook.Sheets[sheetName];
			jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
			jsonData = jsonData.filter(row => Object.values(row).some(cell => cell !== null && cell !== ''));
			jsonData.shift();
			const newData = jsonData.map((row) => {
				const obj = {};
				const amount = Number(row[5]);
				const type = amount > 0 ? 'Debe' : 'Haber';
				obj.amount = amount;
				obj.type = amount > 0 ? 1 : 2;
				obj[`amount${type}`] = type === 'Debe' ? amount : (amount * -1);
				const otherType = type === 'Debe' ? 'Haber' : 'Debe';
				obj[`amount${otherType}`] = 0;
				obj.reference = row[2];
				obj.concept = row[3];
				const objAccount = this.createNewObjAccount(row[0]);
				const objCostCenter = this.createNewObjCostCenter(row[6], row[0]);
				return { ...obj, ...objAccount, ...objCostCenter };
			});
			const isAccountNull = newData.some(a => a.account === null);
			const accountNull = newData.map((a, index) => {
				if (a.account === null) {
					return index;
				}
				return -1;
			});
			const filterIndex = accountNull.filter(a => a > -1);
			this.valuesNotFound = filterIndex.map((f) => {
				const value = jsonData[f];
				return value[0];
			});
			if (isAccountNull) {
				this.showDialog = true;
				const dataFilter = newData.filter(nD => nD.account !== null);
				this.dataSelected = dataFilter;
			} else {
				this.dataSelected = newData;
			}
			this.debit = this.dataSelected.reduce((a, d) => {
				if (Number(d.amount) >= 0) {
					return a + Number(d.amount);
				}
				return a;
			}, 0);
			this.credit = this.dataSelected.reduce((a, d) => {
				if (Number(d.amount) < 0) {
					return Number(d.amount) + a;
				}
				return a;
			}, 0);
			this.balance = this.dataSelected.reduce((acc, item) => {
				const newAmount = Number(item.amount);
				return Number((acc + newAmount).toFixed(2));
			}, 0);
		};
		reader.readAsArrayBuffer(file);
		this.loadingData = false;
		this.$refs.fileInput.value = null;
	}

	function createNewObjAccount(value) {
		const findAccount = this.accounts.find(a => a.account === value || a.account === `${value}.`);
		const objAccount = {
			accountingAccountId: null,
			account: null,
			accountingAccount: {},
		};
		if (findAccount) {
			objAccount.accountingAccountId = findAccount.id;
			objAccount.account = findAccount.code;
			objAccount.accountingAccount = findAccount;
		}
		return objAccount;
	}

	function createNewObjCostCenter(value, accountCode) {
		const objCostCenter = {
			costCenterId: null,
			costCenter: {},
			flagCostCenter: false,
		};
		if (value) {
			const findCostCenter = this.costCenters.find(c => c.name === value);
			if (findCostCenter) {
				objCostCenter.costCenterId = findCostCenter.id;
				objCostCenter.costCenter = findCostCenter;
				objCostCenter.flagCostCenter = accountCode.split('.')[0] === '4'
					|| accountCode.split('.')[0] === '5'
					|| accountCode.split('.')[0] === '6'
					|| accountCode.split('.')[0] === '7'
					|| accountCode.split('.')[0] === '8';
			}
		}
		return objCostCenter;
	}

	function closeAlert() {
		this.showDialog = false;
		this.valuesNotFound = null;
	}

	function onDownloadFormat() {
		const fileUrl = '/static/documents/formato-exportacion.xlsx';
		const fileName = 'formato-exportacion.xlsx';
		fetch(fileUrl)
			.then((response) => {
				if (!response.ok) {
					throw new Error('Error al descargar el archivo.');
				}
				return response.blob();
			})
			.then((blob) => {
				saveAs(blob, fileName);
			})
			.catch((error) => {
				this.showGenericError('Error al descargar el archivo:', error);
			});
	}

	function data() {
		return {
			accountingAccount: {},
			accounts: [],
			action: {
				code: '',
				title: '',
				value: false,
			},
			balance: 0,
			flagDisabledAddSeat: false,
			flagEditInline: false,
			cancelModal: false,
			checkAll: false,
			moduleCode: null,
			codeAccountant: '',
			codeDetailJournal: null,
			codeJournal: null,
			columns: [
				{ id: 1, name: 'Cód. cta. contable', value: 'code', checked: true, visible: true },
				{ id: 3, name: 'Nombre cta. contable', value: 'name', checked: true, visible: true },
				{ id: 4, name: 'Acciones', checked: true, visible: true, flagVisible: true },
			],
			costCenters: [],
			costCenter: {},
			seatRemove: {},
			settings: {},
			credit: 0,
			currentPage: 1,
			documentNumberUpdate: null,
			currentPageRecords: 1,
			dataSelected: [],
			dataSelectedOriginal: [],
			dateDetailJournal: null,
			debit: 0,
			detailJournalOpen: false,
			editDetailInline: false,
			headingSeat: false,
			journalList: true,
			lastPage: 0,
			loading: false,
			loadingFilter: false,
			model: {
				code: '',
				currency: '',
				date: null,
				gloss: '',
				moduleCode: '',
				ruc: '',
			},
			modelDetail: {
				accountingAccountId: null,
				account: null,
				concept: null,
				reference: null,
				costCenterId: null,
				amount: null,
			},
			module: {},
			modules: [],
			moduleName: null,
			moduleValue: {},
			notDeclare: false,
			openDetailSeat: false,
			openMobile: false,
			records: [],
			recordsParams: {
				limit: 60,
				page: 1,
				search: null,
			},
			rowDetail: {},
			rowDetailId: null,
			rowDetailName: '',
			rowId: null,
			rowsIds: [],
			rowIdsModules: [],
			rowIdSeat: null,
			rowName: '',
			rowSelected: {},
			rowsSelected: [],
			rucSubsidiary: null,
			seatDetails: [],
			seccionHeader: {
				balance: null,
				currencySymbol: null,
				should: null,
				toHave: null,
			},
			search: null,
			showHeadingBtn: false,
			showSeatForm: false,
			states: [
				{ id: 1, name: 'Correctos' },
				{ id: 2, name: 'Pendientes' },
			],
			subsidiaries: [],
			toDeclare: false,
			modulesFilter: [],
			flagCostCenter: false,
			flagSquareSeats: false,
			flagCancel: true,
			flagValidCostCenter: false,
			indexRowDetail: null,
			isSquareAmounts: false,
			// Variales usadas en la clonación
			dataSeatClone: {},
			showPreviewClone: false,
			loadingData: false,
			valuesNotFound: null,
			showDialog: false,
		};
	}

	export default {
		name: 'journal',
		beforeDestroy,
		components: {
			actionBar,
			actionSidebar,
			appInputText,
			autocompleteComponent,
			dateComponent,
			headerContent,
			journalCancelForm,
			journalDetail,
			journalDetailDeleteForm,
			journalDetailForm,
			journalFilter,
			appTooltipButton,
			journalFilterBy,
			journalList,
			journalSeatForm,
			slideSearcher,
			journalDetailAdd,
			previewClone,
			closeIcon,
		},
		computed: {
			...mapGetters('subsidiary', [
				'currentSubsidiary',
			]),
			accountingName,
			actionsDisabled,
			disabledFormClean,
			disabledFormSave,
			typeDetail,
			disabledCostCenter,
			disabledBtnAdd,
			validInsertCostCenter,
			validButtonCostCenter,
		},
		created,
		data,
		methods: {
			addDetail,
			removeItem,
			addIcon,
			getSquareLabel,
			getModuleLabel,
			getStatusLabel,
			addDetailSeat,
			cleanAll,
			isActionCode,
			saveAccouting,
			addRecord,
			changePageRecords,
			changeAmount,
			closeDialog,
			closeModal,
			currencySymbol,
			deleteJournal,
			createAction,
			createDetailSeat,
			confirmCancel,
			filterBy,
			inlineEditDetail,
			loadAccounts,
			loadCostCenters,
			loadDetail,
			loadModules,
			loadRecords,
			loadStates,
			searchFilterJournal,
			onAction,
			onClean,
			onClick,
			onClickIcon,
			onDelete,
			onDeleteSeat,
			onDeleteSeatMultiple,
			onDeleteSeatInline,
			onEditHeading,
			onInput,
			onInputDetail,
			onKeyPress,
			onPage,
			onSave,
			onSaveDetail,
			onSaveMultiple,
			onSearch,
			onSearchDetail,
			onSearchRecords,
			onSelectedAll,
			onTableOption,
			detailJournalList,
			openSearcher,
			openDetail,
			returnJournal,
			rowIsSelected,
			runAction,
			saveDetailSeat,
			setHeadingData,
			setId,
			setModel,
			subsidiaryChange,
			clickFilter,
			clearFilter,
			clearFilterMobile,
			mobileDetail,
			closeMobile,
			seeDetail,
			selectDetail,
			setCostCenter,
			setData,
			changeDate,
			setModelData,
			setModuleData,
			setDataDetail,
			saveAllDetailsEdits,
			formatData,
			saveNewDetailSeat,
			clearModels,
			onDeleteDetailSeat,
			validateAmountActions,
			cancelEditionDetail,
			cloneSeat,
			closePreview,
			printSeat,
			closeModelDelete,
			importExcel,
			handleFileUpload,
			createNewObjAccount,
			createNewObjCostCenter,
			closeAlert,
			onDownloadFormat,
		},
		mounted,
		props: {
			subsidiaryId: [Number, String],
		},
		watch: {
			currentSubsidiary: subsidiaryChange,
			rowSelected: {
				handler(newVal, oldVal) {
					if (newVal !== oldVal) {
						this.openDetailSeat = false;
						this.modelDetail = {
							accountingAccountId: null,
							account: null,
							concept: '',
							reference: '',
							costCenterId: null,
							amount: null,
						};
						this.accountingAccount = {};
						this.editDetailInline = false;
					}
				},
			},
		},
	};
</script>

<style lang="scss" scoped>
.border-left {
	border-left: 2px solid map-get($colors, grey-icon);
}
.waitProgress {
	background-color: #03A89E !important;
	border-radius: 10px;
}

.btn-modal {
	border-radius: 30px;
	color: map-get($colors, white);
	height: 30px;
	padding: 0px 20px;
	width: 93px;
}

.save {
	background-color: color(secondary);
}

.cancel {
	background-color: color(error);
}

.content-journal-heading {
	position: relative;
	left: 10px;
	@media (max-width: 768px) {
		width: 100%;
		position: absolute;
		left: 0px;
		z-index: 1 !important;
	}
}
.should-color {
	background-color: #77a1d1;
		border-radius: 10px;
		height: 31px;
		@media (max-width: 768px) {
			font-size: 11px;
			width: 194px;
			display: none;
		}
		.debitV {
			width: 174px;
			height: 20px;
			font-family: 'AvenirRegular';
			font-size: 14px;
			font-weight: 500;
			font-stretch: normal;
			font-style: normal;
			line-height: 1.54;
			letter-spacing: normal;
			text-align: center;
			color: white;
		}
	}
.content-red {
	opacity:0.7;
	background-color: #f22d20;
	color: map-get($colors, red-icon);
	.debitC {
		width: 174px;
		height: 20px;
		font-family: monospace;
		font-size: 12px;
		font-weight: 500;
		font-stretch: normal;
		font-style: normal;
		line-height: 1.54;
		letter-spacing: normal;
		text-align: center;
		color: white;
	}
}
.btnCloseDialog {
	margin: 0;
	background-color:red;
	height:20px;
	width:20px;
}

.content-blue {
	opacity:0.7;
	background-color: #02979b ;
	color: map-get($colors, secondary);
	.debitV {
		width: 174px;
		height: 20px;
		font-family: monospace;
		font-size: 12px;
		font-weight: 500;
		font-stretch: normal;
		font-style: normal;
		line-height: 1.54;
		letter-spacing: normal;
		text-align: center;
		color: white;
	}

}

.content-gray {
	opacity:0.9;
	background-color: #696cff;
	color: map-get($colors, white);
	.debitB {
		width: 174px;
		height: 20px;
		font-family: monospace;
		font-size: 12px;
		font-weight: 500;
		font-stretch: normal;
		font-style: normal;
		line-height: 1.54;
		letter-spacing: normal;
		text-align: center;
		color: white;
	}
}
.background-gray-mobile {
	background-color: #eceff1;
	padding: 5px 19px;
}

.color-blue {
	color: #006edb;
	font-family: map-get($fonts, AvenirDemi);
	font-size: map-get($sizes, small);
}
.titleCard {
	background-color: #03A89E !important;
	@include flex-between;
}

.color-red {
	color: #ff0000;
	font-family: map-get($fonts, AvenirDemi);
	font-size: map-get($sizes, small);
}

.background-balance {
	color: white;
	font-size: 12px;
	font-family: map-get($fonts, AvenirBold);
	padding: 5px 17px;
}
.createSeat{
  border-radius: 10px;
}
.mobile-none {
	@media (max-width: 768px) {
		display: none;
	}
}

.height-input {
	min-height: 24px;
	padding-top: 3px;
}

.btn-clear-filter {
	background-color: map-get($colors, text-red-light);
	border-radius: 13px;
	color: map-get($colors, white);
	font-size: 12px;
	padding: 4px 10px;

	@media (min-width: 768px) {
		display: none;
	}
}
.CardSeat {
	border-radius: 13px;
}

.content-detail {
	float: left;
	width: 40%;
	position: fixed;
	top: 135px;
	right: 20px;
	border-radius: 10px;
	border: PowderBlue 5px solid;
	height: calc(100vh - 150px);
	@media (max-width: 768px) {
		left: -100%;
		position: absolute;
		transition: all .2s ease-in-out 0s;
		z-index: 2;

		&.open {
			left: 0;
		}
	}
}

.background-heading {
	background-color: #f4f6f8;
	padding-left: 25px;
}

.title-heading {
	background-color: #f1f4fa;
	color: color(black);
	font-family: font(AvenirBold);
	font-size: size(medium);
	height: 25px;
	text-align: center;
}

.body-seat-form {
	background-color: #f1f4fa;
	padding: 10px 12px;
}
.title-modal {
	color: color(secondary);
	font-size: size(medium18);
	margin: 150px auto 0px;
	max-width: 400px;
}
.card-container {
	display: flex;
	flex-direction: column;
	padding: 5px;
	&-title {
		display: flex;
		justify-content: end;
		align-items: end;
		padding: 2px;
	}
	&-list {
		color: color(grey-text);
		font-size: size(small);
		padding: 3px;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/journal/page-journal.vue